import React from "react";
// import { RWebShare } from "react-web-share";

import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    GabShareButton,
    GabIcon,
    HatenaShareButton,
    HatenaIcon,
    InstapaperShareButton,
    InstapaperIcon,
    LineShareButton,
    LineIcon,
    LinkedinShareButton,
    LinkedinIcon,
    LivejournalShareButton,
    LivejournalIcon,
    MailruShareButton,
    MailruIcon,
    OKShareButton,
    OKIcon,
    PinterestShareButton,
    PinterestIcon,
    PocketShareButton,
    PocketIcon,
    RedditShareButton,
    RedditIcon,
    TelegramShareButton,
    TelegramIcon,
    TumblrShareButton,
    TumblrIcon,
    ViberShareButton,
    ViberIcon,
    VKShareButton,
    VKIcon,
    WorkplaceShareButton,
    WorkplaceIcon,
} from "react-share";
  

import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

export default function SocialShare({referCode}) {
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div>
          <Button variant="contained" {...bindTrigger(popupState)}>
          <i className="fa fa-share-alt" title="Share"></i>
          </Button>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <div className="socialShareList">
                <FacebookShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <FacebookIcon size={32} round />
                </FacebookShareButton>
                <EmailShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <EmailIcon size={32} round />
                </EmailShareButton>
                <TwitterShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <TwitterIcon size={32} round />
                </TwitterShareButton>
                <WhatsappShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <LinkedinShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                
                {/* <GabShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <GabIcon size={32} round />
                </GabShareButton>
                <HatenaShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <HatenaIcon size={32} round />
                </HatenaShareButton>
                <InstapaperShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <InstapaperIcon size={32} round />
                </InstapaperShareButton>
                <LineShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <LineIcon size={32} round />
                </LineShareButton>
                <LivejournalShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <LivejournalIcon size={32} round />
                </LivejournalShareButton>
                <MailruShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <MailruIcon size={32} round />
                </MailruShareButton>
                <OKShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <OKIcon size={32} round />
                </OKShareButton>
                <PinterestShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <PinterestIcon size={32} round />
                </PinterestShareButton>
                <PocketShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <PocketIcon size={32} round />
                </PocketShareButton>
                <RedditShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <RedditIcon size={32} round />
                </RedditShareButton>
                <TelegramShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <TelegramIcon size={32} round />
                </TelegramShareButton>
                <TumblrShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <TumblrIcon size={32} round />
                </TumblrShareButton>
                <ViberShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <ViberIcon size={32} round />
                </ViberShareButton>
                <VKShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <VKIcon size={32} round />
                </VKShareButton>
                <WorkplaceShareButton url={`http://hearing.codingserver.com/Signup/?refer=${referCode}`} className="Demo__some-network__share-button">
                    <WorkplaceIcon size={32} round />
                </WorkplaceShareButton> */}
            </div>
            
          </Popover>
        </div>
      )}
    </PopupState>
  );
}


